import { createApi } from "@reduxjs/toolkit/query/react";
import { CURRENCIES, VITE_API_V2_URL } from "codes";
import { axiosBaseQuery } from "helpers/axiosbaseQuery";
import type { WithdrawalDeposit } from "./api-marketplace.d";

const formatCurrencies = (accountCurrencies: string[]) => {
  const currencies = Object.entries(CURRENCIES)
    ?.filter(([key]) => !accountCurrencies || accountCurrencies.includes(key))
    .map(([key, value]) => ({
      label: key,
      value: key,
      ...value,
    }));
  return currencies;
};

export const investor = createApi({
  reducerPath: "investor",
  baseQuery: axiosBaseQuery({
    baseUrl: `${VITE_API_V2_URL}/dashboard`,
  }),
  tagTypes: ["INVESTOR_BANKS", "INVESTOR_CURRENCIES", "INVESTOR_WITHDRAWAL"],
  endpoints: (builder) => ({
    getInvestorAccountBanks: builder.query<
      {
        id: string;
        name: string;
        bank_name: string;
        bank_account_number: string;
        bank_address: string;
        beneficiary_name: string;
        iban: string;
        swift_code: string;
        currency: string;
        sf_bank_account_id: string;
      }[],
      string
    >({
      query: (funder_id) => ({
        url: `/funder/${funder_id}/banks`,
        method: "get",
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["INVESTOR_BANKS"],
    }),
    getInvestorCurrencies: builder.query<any, string>({
      query: (funder_id) => ({ url: `/funder/${funder_id}/currencies`, method: "get" }),
      transformResponse: (response) => formatCurrencies(response?.data),
      providesTags: ["INVESTOR_CURRENCIES"],
    }),
    submitInvestorWithdrawal: builder.mutation<
      any,
      { funder_id: string; data: WithdrawalDeposit }
    >({
      query: ({ funder_id, data }) => {
        return {
          url: `/funder/${funder_id}/withdrawal-deposit`,
          method: "POST",
          data,
        };
      },
      invalidatesTags: ["INVESTOR_WITHDRAWAL"],
      transformResponse: (response) => response?.data,
    }),
  }),
});

export const {
  useGetInvestorAccountBanksQuery,
  useGetInvestorCurrenciesQuery,
  useSubmitInvestorWithdrawalMutation,
} = investor;
